import {writeFragmentsToCache} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {AnalyticsDashboardLinkParentSpecRequest} from 'insights/embeddings/RESTEmbeddingTypes';
import * as TagSchemaDAO from 'tag-schema/TagSchemaDAO';

export async function embedInsightsIntoTagSchema(
  tagSchemaId: string,
  data: AnalyticsDashboardLinkParentSpecRequest
): Promise<void> {
  const response = await TagSchemaDAO.embedInsights(tagSchemaId, data);
  writeFragmentsToCache(getFragmentWrapper('AnalyticsDashboardLinkParent'), [response.tagSchema]);
}
